import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18950a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-2 p-5 overflow-x-auto" }
const _hoisted_2 = { class: "box flex flex-col gap-4 justify-between min-w-max lg:flex-row" }
const _hoisted_3 = { class: "flex gap-4 items-center justify-between w-full lg:justify-start" }
const _hoisted_4 = { class: "flex flex-col items-center lg:w-44" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Orders this month", -1))
const _hoisted_6 = { class: "text-title" }
const _hoisted_7 = { class: "flex flex-col items-center lg:w-44" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Orders this year", -1))
const _hoisted_9 = { class: "text-title" }
const _hoisted_10 = { class: "flex flex-col items-center lg:w-44" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Orders all time", -1))
const _hoisted_12 = { class: "text-title" }
const _hoisted_13 = { class: "flex gap-4 items-center justify-between w-full lg:justify-end" }
const _hoisted_14 = { class: "flex flex-col items-center lg:w-44" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Earnings this month", -1))
const _hoisted_16 = { class: "text-title" }
const _hoisted_17 = { class: "flex flex-col items-center lg:w-44" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Earnings this year", -1))
const _hoisted_19 = { class: "text-title" }
const _hoisted_20 = { class: "flex flex-col items-center lg:w-44" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Earnings all time", -1))
const _hoisted_22 = { class: "text-title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between p-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Open Orders")
  ])
], -1))
const _hoisted_24 = { class: "flex gap-2 justify-between px-5 py-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View All Orders", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "flex flex-col gap-2 overflow-x-auto p-5" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"box-head justify-between\" data-v-18950a72><div class=\"flex gap-4 items-center\" data-v-18950a72><div class=\"w-14\" data-v-18950a72></div><div class=\"w-44\" data-v-18950a72><span class=\"text-order\" data-v-18950a72>Store Name</span></div><div class=\"w-36\" data-v-18950a72><span class=\"text-order\" data-v-18950a72>Customer</span></div><div class=\"w-24\" data-v-18950a72><span class=\"text-order\" data-v-18950a72>Ordered</span></div><div class=\"flex justify-center w-24\" data-v-18950a72><span class=\"text-order\" data-v-18950a72>Type</span></div><div class=\"flex justify-center w-44\" data-v-18950a72><span class=\"text-order\" data-v-18950a72>Deliver Time</span></div></div><div class=\"flex gap-4 items-center\" data-v-18950a72><div class=\"flex justify-center w-36\" data-v-18950a72><span class=\"text-order\" data-v-18950a72>Status</span></div><div class=\"flex justify-end w-16\" data-v-18950a72><span class=\"text-order\" data-v-18950a72>Total</span></div></div></div>", 1)
const _hoisted_29 = ["to", "onClick"]
const _hoisted_30 = { class: "flex gap-4 items-center" }
const _hoisted_31 = { class: "w-14" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "flex flex-col w-44" }
const _hoisted_34 = { class: "text-title" }
const _hoisted_35 = { class: "text" }
const _hoisted_36 = { class: "w-36" }
const _hoisted_37 = { class: "text" }
const _hoisted_38 = { class: "flex flex-col w-24" }
const _hoisted_39 = { class: "text" }
const _hoisted_40 = { class: "text" }
const _hoisted_41 = { class: "flex justify-center w-24" }
const _hoisted_42 = { class: "text" }
const _hoisted_43 = { class: "flex justify-center w-44" }
const _hoisted_44 = { class: "text" }
const _hoisted_45 = { class: "flex gap-4 items-center" }
const _hoisted_46 = { class: "flex justify-center w-36" }
const _hoisted_47 = { class: "flex justify-end w-16" }
const _hoisted_48 = { class: "text-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseAutocomplete = _resolveComponent("BaseAutocomplete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.response.MonthCount || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.response.YearCount || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.response.Count || 0), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.helpers.toCurrency(_ctx.response.MonthTotal || 0)), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.helpers.toCurrency(_ctx.response.YearTotal || 0)), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.helpers.toCurrency(_ctx.response.Total || 0)), 1)
          ])
        ])
      ])
    ]),
    _hoisted_23,
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/order'))),
        class: "button-light"
      }, _hoisted_26),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_BaseAutocomplete, {
            itemsOrder: _ctx.Orders,
            itemsStore: _ctx.store,
            filterOrder: _ctx.OrderFilter,
            storeItemText: _ctx.joinedByStoreId,
            userItemText: _ctx.joinedByCustomerId,
            onFilter: _ctx.updateData,
            onClose: _ctx.updateData
          }, null, 8, ["itemsOrder", "itemsStore", "filterOrder", "storeItemText", "userItemText", "onFilter", "onClose"])
        ]),
        _: 1
      }))
    ]),
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Orders, ({
            Id,
            UniqueId,
            Store: {
                Name,
                Logo
            },
            Customer: {
                FirstName,
                LastName
            },
            PlacedAt,
            DeliveryType,
            // DeliveredAt,
            DeliveryTime,
            PickupTime,
            Status,
            DiscountedTotal
        }, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "box justify-between min-w-max cursor-pointer",
          key: idx,
          to: { name: 'id', params: { id: Id } },
          onClick: ($event: any) => (_ctx.$router.push(`/order/${Id}`))
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("img", {
                src: `${_ctx.configMedia.mediaUrl}/${Logo}`,
                class: "store-icon",
                onerror: "this.style.display = 'none'"
              }, null, 8, _hoisted_32)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("p", _hoisted_34, _toDisplayString(Name), 1),
              _createElementVNode("span", _hoisted_35, _toDisplayString(UniqueId), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("span", _hoisted_37, _toDisplayString(FirstName + ' ' + LastName), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.helpers.formatDate(new Date(PlacedAt), 'HH:mm')), 1),
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.helpers.formatDate(new Date(PlacedAt), 'd.M.yyyy')), 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.helpers.upperFirst(DeliveryType).replaceAll('-', ' ')), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.getDateOrAsap({ DeliveryType, DeliveryTime,
                            PickupTime })), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", {
                class: "button-order-status",
                style: _normalizeStyle({ 'color': `${_ctx.helpers.getOrderStatusColor(Status)}`, 'background-color': `${_ctx.helpers.getOrderStatusBackgroundColor(Status)}` })
              }, [
                _createElementVNode("span", null, _toDisplayString(Status), 1)
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.helpers.toCurrency(DiscountedTotal)), 1)
            ])
          ])
        ], 8, _hoisted_29))
      }), 128))
    ])
  ], 64))
}